module.exports = __webpack_public_path__ + "img/index_card_selfGi.e3904dae.svg";